module.exports = __webpack_public_path__ + "img/theme7.21857947.png";